import React from 'react'
import PropTypes from 'prop-types'

const OfferSearchPrice = ({
  priceInternal,
  price_internal_title,
  priceExternal,
  price_external_title,
  priceCurrency,
  className,
}) => {
  return (
    <>
      {'number' === typeof priceInternal && (
        <p className={className}>
          {price_internal_title ? price_internal_title : 'Für AOK Versicherte'}:{' '}
          <b>{0 < priceInternal ? `${priceInternal}${priceCurrency ? priceCurrency : '€'}` : 'Kostenlos'}</b>
        </p>
      )}
      {'number' === typeof priceExternal && (
        <p className={className}>
          {price_external_title ? price_external_title : 'Für Fremdversicherte'}:{' '}
          <b>{0 < priceExternal ? `${priceExternal}${priceCurrency ? priceCurrency : '€'}` : 'Kostenlos'}</b>
        </p>
      )}
    </>
  )
}

OfferSearchPrice.propTypes = {
  priceInternal: PropTypes.number,
  price_internal_title: PropTypes.string,
  priceExternal: PropTypes.number,
  price_external_title: PropTypes.string,
  priceCurrency: PropTypes.string,
  className: PropTypes.string,
}

OfferSearchPrice.defaultProps = {
  priceCurrency: '€',
  className: '',
}

export default OfferSearchPrice
